var React = require('react');

function IconDoorExit (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"primary","d":"M11 4h3a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0V6h-2v12h2v-2a1 1 0 0 1 2 0v3a1 1 0 0 1-1 1h-3v1a1 1 0 0 1-1.27.96l-6.98-2A1 1 0 0 1 2 19V5a1 1 0 0 1 .75-.97l6.98-2A1 1 0 0 1 11 3v1z","key":0}),React.createElement("path",{"className":"secondary","d":"M18.59 11l-1.3-1.3c-.94-.94.47-2.35 1.42-1.4l3 3a1 1 0 0 1 0 1.4l-3 3c-.95.95-2.36-.46-1.42-1.4l1.3-1.3H14a1 1 0 0 1 0-2h4.59z","key":1})]);
}

IconDoorExit.defaultProps = {"viewBox":"0 0 24 24","className":"icon-door-exit"};

module.exports = IconDoorExit;

IconDoorExit.default = IconDoorExit;
